const translations = {
    createApplicationMap: 'Create Application Map',
    customer: 'Customer',
    delete: 'Delete',
    drone: 'Drone',
    job: 'Job/WO',
    pilot: 'Pilot',
    site: 'Site',
    startTime: 'Start Time',
    totalFlightTime: 'Total Flight Time',
    totalFlights: 'Total Flights',
    view: 'View'
};

export default translations;
